import {
  defaultGroupMember,
  defaultSystemCode,
  defaultUserAddress,
  exists,
  GroupMember,
  GroupMemberFromJSON,
  MailAddress,
  MailAddressFromJSON,
  OldAddress,
  OldAddressFromJSON,
  OldName,
  OldNameFromJSON,
  SystemCode,
  SystemCodeFromJSON,
  UserAddress,
  UserAddressFromJSON,
  UserOtherContact,
  UserOtherContactFromJSON,
  UserPhone,
  UserPhoneFromJSON
} from '@/api'

export interface UserGroup {
  name: string
  nameKana: string
  userAddress: UserAddress
  phones: UserPhone[]
  mailAddresses: MailAddress[]
  groupType: SystemCode
  groupMember: GroupMember
  guardian: string
  guardianKana: string
  otherContacts: UserOtherContact[]
  oldNames: OldName[]
  oldAddresses: OldAddress[]
}

export function UserGroupFromJSON(json: any): UserGroup {
  return {
    name: exists(json, 'name') ? json.name : '',
    nameKana: exists(json, 'name_kana') ? json.name_kana : '',
    userAddress: UserAddressFromJSON(json.user_address),
    phones: (json.phones as any[]).map(UserPhoneFromJSON),
    mailAddresses: (json.mail_addresses as any[]).map(MailAddressFromJSON),
    groupType: exists(json, 'group_type')
      ? SystemCodeFromJSON(json.group_type)
      : defaultSystemCode(),
    groupMember: GroupMemberFromJSON(json.group_member),
    guardian: exists(json, 'guardian') ? json.guardian : '',
    guardianKana: exists(json, 'guardian_kana') ? json.guardian_kana : '',
    otherContacts: (json.other_contacts as any[]).map(UserOtherContactFromJSON),
    oldNames: (json.old_names as any[]).map(OldNameFromJSON),
    oldAddresses: (json.old_addresses as any[]).map(OldAddressFromJSON)
  }
}

export const defaultUserGroup = (): UserGroup => ({
  name: '',
  nameKana: '',
  userAddress: defaultUserAddress(),
  phones: [],
  mailAddresses: [],
  groupType: defaultSystemCode(),
  groupMember: defaultGroupMember(),
  guardian: '',
  guardianKana: '',
  otherContacts: [],
  oldNames: [],
  oldAddresses: []
})
